<template>
    <div class="page-wrapper">
        <div class="page-body">

            <div class="page page-center" v-if="activePromisesDJB > 0 || activePromisesDJCI > 0 ">
                <div class="container container-slim py-4">
                    <div class="text-center">
                        <div class="mb-3">
                            <i class="fas fa-exclamation-circle" style="color: #285289;"></i>                            
                        </div>
                        <div class="text-muted mb-3">Realizando consulta..</div>
                        <div class="progress progress-sm">
                            <div class="progress-bar progress-bar-indeterminate" style="background-color: #285289;"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container-xl" v-if="activePromisesDJB == 0 || activePromisesDJCI == 0">
                <h1 class="text-center">Bienvenidos al Portal de Declaraciones Juradas de Funcionarios Públicos</h1>
            
                <div class="row row-deck row-cards">    
                    <div class="col-12">
                        <div class="card card-md">
                            <div class="card-body">
                                <Form @submit="buscar" class="row align-items-center">
                                    <div class="col-5">
                                        <Field type="text" class="form-control" name="nombre"
                                            placeholder="Busqueda por Nombre y/o Apellido"
                                            v-model="nombreBusqueda" autocomplete="false" />
                                        <ErrorMessage name="nombre" class="help is-danger" style="color:red"></ErrorMessage>
                                    </div>
                                    <div class="col-4">
                                        <Field type="text" class="form-control"
                                            name="cedula" placeholder="Busqueda por Cédula"
                                            v-model="cedulaBusqueda" autocomplete="false" />
                                        <ErrorMessage name="cedula" class="help is-danger" style="color:red"></ErrorMessage>
                                    </div>
                                    <div class="col-3">
                                        <button href="https://tabler-icons.io" class="btn btn-primary" target="_blank" rel="noopener">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-search" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                                                <path d="M21 21l-6 -6"></path>
                                            </svg>
                                            Buscar
                                        </button>
                                    </div>
                                </Form>
                                <br/>
                                <div class="row aling-items-center">
                                    <h3><strong> Aclaración sobre los Registros con Opción de Generar Reporte y Escaneado en nuestra Base de Datos Abiertos</strong></h3>
                                    <p>
                                        En nuestro portal de datos abiertos, nos esforzamos por proporcionar acceso transparente y completo a la información que ofrecemos. 
                                        Sin embargo, es importante tener en cuenta que algunos registros pueden presentar variaciones en su formato, dependiendo de su origen y procesamiento. 
                                        En este sentido, solicitamos revisar el apartado <router-link   to="/acerca-de">Acerca de</router-link> para clarificar la diferencia entre los registros que tienen como origen la opción <strong>ESCANEADO o SISTEMA</strong>  y garantizar una comprensión precisa de los datos disponibles.                                    
                                        
                                    </p>                                                                          
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br>

                <div class="row row-deck row-cards">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Declaraciones Juradas de Bienes y Rentas</h3>
                            </div>
                            <div class="table-responsive">
                                <table class="table card-table table-vcenter text-nowrap datatable">
                                    <thead>
                                        <tr>
                                            <th>Nombre y Apellido</th>
                                            <th>Cédula de Identidad</th>
                                            <th>Periodo</th>
                                            <th>Origen</th>
                                            <th>Descarga</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="totalPaginaDjb == 0">
                                            <td class="col-12 text-muted">{{ msgDjb }}</td>
                                        </tr>
                                        <tr v-for="(listaDJB) in listadoDJB" :key="listaDJB.id">
                                            <td class="col-6">{{ listaDJB.nombres }}</td>
                                            <td class="col-2">{{ listaDJB.cedula }}</td>
                                            <td class="col-1">{{ listaDJB.periodo }}</td>
                                            <td class="col-1">
                                                <span v-if="listaDJB.fisico == false" class="badge badge-outline text-secondary fw-normal badge-pill">Sistema</span>
                                                <span v-if="listaDJB.fisico == true" class="badge badge-outline text-secondary fw-normal badge-pill">Escaneado</span>
                                            </td>
                                            <td class="col-2">
                                                <div class="row g-2 align-items-center">
                                                    <div class="col-12">
                                                        <button v-if="listaDJB.fisico == false" class="btn btn-sm btn-success w-40" @click="descargarDjbPDF(listaDJB.id, listaDJB.idCabeceraDjb, listaDJB.nombres)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-download" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                                <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                                                <path d="M7 11l5 5l5 -5"></path>
                                                                <path d="M12 4l0 12"></path>
                                                            </svg>
                                                            PDF
                                                        </button>
                                                        <button v-if="listaDJB.fisico == true" class="btn btn-sm btn-success w-40" @click="descargarDjbPDF(listaDJB.id, listaDJB.cedula, listaDJB.nombres)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-download" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                                <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                                                <path d="M7 11l5 5l5 -5"></path>
                                                                <path d="M12 4l0 12"></path>
                                                            </svg>
                                                            PDF
                                                        </button>
                                                        &nbsp;
                                                        <button class="btn btn-sm btn-secondary w-40" v-if="listaDJB.fisico == false" @click="descargarDjbJSON(listaDJB.id, listaDJB.idCabeceraDjb, listaDJB.nombres)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-file-download" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                                <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                                                                <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                                                                <path d="M12 17v-6"></path>
                                                                <path d="M9.5 14.5l2.5 2.5l2.5 -2.5"></path>
                                                            </svg>
                                                            JSON
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer d-flex align-items-center">
                                <div class="m-0 text-secondary col-6">
                                    <span>Mostrar</span>
                                    <div class="mx-2 d-inline-block">
                                        <div class="form-group">
                                            <select id="per-page-select" v-model="perPageDjb" @change="handlePerPageDjb" class="form-control form-control-sm">
                                                <option v-for="(option, index) in pageOptionsDjb" :value="option" :key="index">{{ option }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <span>registros de </span>
                                    <span>{{ cantPaginasDjb }}</span>
                                    <span> Declaraciones Juradas de Bienes y Rentas</span>
                                </div>
                                <div class="pagination m-0 ms-auto">
                                    <div class="pagination">
                                        <button class="page-link" @click="paginaPrimeraDjb" :disabled="currentPageDjb === 1">
                                            Primero
                                        </button>
                                        <button class="page-link" @click="paginaAnteriorDjb" :disabled="currentPageDjb === 1">
                                            Anterior
                                        </button>
                                        <span class="page-link">{{ currentPageDjb }} de {{ totalPaginaDjb }}</span>
                                        <button class="page-link" @click="paginaSiguienteDjb" :disabled="currentPageDjb === totalPaginaDjb">
                                            Siguiente
                                        </button>
                                        <button class="page-link" @click="paginaUltimaDjb" :disabled="currentPageDjb === totalPaginaDjb">
                                            Último
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br>

                <div class="row row-deck row-cards">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">Declaraciones Juradas de Intereses</h3>
                            </div>
                            <div class="table-responsive">
                                <table class="table card-table table-vcenter text-nowrap datatable">
                                    <thead>
                                        <tr>
                                            <th>Nombre y Apellido</th>
                                            <th>Cédula de Identidad</th>
                                            <th>Periodo</th>
                                            <th>Origen</th>
                                            <th>Descarga</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="totalPaginaDjci == 0">
                                            <td class="col-12 text-muted">{{ msgDjci }}</td>
                                        </tr>
                                        <tr v-for="(listaDJCI) in listadoDJCI" :key="listaDJCI.idCabecera">
                                            <td class="col-6">{{ listaDJCI.nombres }}</td>
                                            <td class="col-2">{{ listaDJCI.cedula }}</td>
                                            <td class="col-1">{{ listaDJCI.periodo }}</td>
                                            <td class="col-1">
                                                <span class="badge badge-outline text-secondary fw-normal badge-pill">Sistema</span>
                                            </td>
                                            <td class="col-2">
                                                <div class="row g-2 align-items-center">
                                                    <div class="col-12">
                                                        <button class="btn btn-sm btn-success w-40" @click="descargarDjciPDF(listaDJCI.idCabecera, listaDJCI.cedula, listaDJCI.nombres)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-download" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                                <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"></path>
                                                                <path d="M7 11l5 5l5 -5"></path>
                                                                <path d="M12 4l0 12"></path>
                                                            </svg>
                                                            PDF
                                                        </button>
                                                        &nbsp;
                                                        <button class="btn btn-sm btn-secondary w-40" @click="descargarDjciJSON(listaDJCI.idCabecera, listaDJCI.idCabeceraDjb, listaDJCI.nombres)">
                                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-file-download" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                                <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                                                                <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                                                                <path d="M12 17v-6"></path>
                                                                <path d="M9.5 14.5l2.5 2.5l2.5 -2.5"></path>
                                                            </svg>
                                                            JSON
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer d-flex align-items-center">
                                <div class="m-0 text-secondary">
                                    <span>Mostrar</span>
                                    <div class="mx-2 d-inline-block">
                                        <div class="form-group">
                                            <select id="per-page-select" v-model="perPageDjci" @change="handlePerPageDjci" class="form-control form-control-sm">
                                                <option v-for="(option, index) in pageOptionsDjci" :value="option" :key="index">{{ option }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <span>registros de </span>
                                    <span>{{ cantPaginasDjci }}</span>
                                    <span> Declaraciones Juradas de Intereses</span>
                                </div>
                                <div class="pagination m-0 ms-auto">
                                    <div class="pagination">
                                        <button class="page-link" @click="paginaPrimeraDjci" :disabled="currentPageDjci === 1">Primero</button>
                                        <button class="page-link" @click="paginaAnteriorDjci" :disabled="currentPageDjci === 1">Anterior</button>
                                        <span class="page-link">{{ currentPageDjci }} de {{ totalPaginaDjci }}</span>
                                        <button class="page-link" @click="paginaSiguienteDjci" :disabled="currentPageDjci === totalPaginaDjci">Siguiente</button>
                                        <button class="page-link" @click="paginaUltimaDjci" :disabled="currentPageDjci === totalPaginaDjci">Último</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</template>
<script>
import datosService from '@/services/datos.service';
import { Form, Field, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 5000,
    timerProgressBar: false,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

export default {
    name: 'PortalDjbr',
    data() {
        return {
            nombre: '',
            cedula: '',
            nombreBusqueda: '',
            cedulaBusqueda: '',
            listadoDJB: [],
            listadoDJCI: [],
            params: '',

            total: "",
            perPageDjb: 5,
            currentPageDjb: 1,
            currentBandDjb: 0,
            inicioDjb: 0,
            pageOptionsDjb: [5, 10, 20, 50],
            sortByDjb: "id",
            sortDescDjb: false,
            filterDjb: null,
            totalPaginaDjb: 0,
            msgDjb: 'Ingrese un criterio de busqueda.',
            cantPaginasDjb: 0,

            perPageDjci: 5,
            currentPageDjci: 1,
            currentBandDjci: 0,
            inicioDjci: 0,
            pageOptionsDjci: [5, 10, 20, 50],
            sortByDjci: "id",
            sortDescDjci: false,
            filterDjci: null,
            totalPaginaDjci: 0,
            msgDjci: 'Ingrese un criterio de busqueda.',
            cantPaginasDjci: 0,

            activePromisesDJB: 0,
            activePromisesDJCI: 0,
        }
    },
    
    components: {
        Form, Field, ErrorMessage
    },
    
    methods: {
        
        buscar() {
            this.listadoDJB = [];
            this.listadoDJCI = [];
            this.totalPaginaDjb = 0
            this.msgDjb = 'Ingrese un criterio de busqueda.';
            this.totalPaginaDjci = 0;
            this.currentPageDjb = 1;
            this.msgDjci = 'Ingrese un criterio de busqueda.';
            this.currentPageDjci = 1;
            if(this.nombreBusqueda == '' && this.cedulaBusqueda == '') {
                Toast.fire({
                    icon: 'warning',
                    title: 'Por favor, complete al menos un criterio de búsqueda.'
                });

                // Swal.fire({
                //     title: 'Por favor, complete al menos un criterio de búsqueda.',
                //     width: 600,
                //     padding: '3em',
                //     color: '#716add',
                //     background: '#fff url(/images/trees.png)',
                //     backdrop: `
                //         rgba(0,0,123,0.4)
                //         url("https://sweetalert2.github.io/images/nyan-cat.gif")
                //         left top
                //         no-repeat
                //     `
                // });

                Swal.fire({
                    icon: 'error',
                    // title: 'Oops...',
                    text: 'Por favor, complete al menos un criterio de búsqueda.',
                    confirmButtonColor: '#285289',
                    // footer: '<a href="">Why do I have this issue?</a>'
                });

            } else {

                this.nombre = this.nombreBusqueda;
                this.cedula = this.cedulaBusqueda;
                this.paginarDJB();
                this.paginarDJCI();

            }
        },

        // Método para realizar la carga y el paginado de los datos de declaraciones juradas de bienes y rentas
        paginarDJB() {
            console.log('paginar DJB');
            this.activePromisesDJB++;
            const params = this.getRequestParamsDJB(
                this.inicioDjb,
                this.currentPageDjb,
                this.currentBandDjb,
                this.perPageDjb,
                this.nombre,
                this.cedula);

                console.log('lista parametros', this.params);
                datosService.getDatosAbiertosDjb(params)           
                .then((response) => {
                    let cantRegDjb = response.data.total;
                    if (cantRegDjb > 0) {
                        this.listadoDJB = response.data.lista;
                    } else {
                        this.msgDjb = 'No se encontraron registros';
                    }
                    this.totalPaginasDjb(response.data.total);
                    this.cantPaginasDjb = response.data.total;
                    this.activePromisesDJB--;
                },
                (error) => {
                    this.content =
                    (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                }

                )
                //.finally(() => {
                //    this.paginarDJCI();
                //    this.activePromisesDJB--;
                //});
        },
        getRequestParamsDJB(inicioDjb, currentPageDjb, currentBandDjb, perPageDjb, nombre, cedula) {

            if (currentPageDjb >= currentBandDjb) {
                this.inicioDjb = (currentPageDjb - 1) * perPageDjb;
                this.currentBandDjb = currentPageDjb;
            } else {
                this.inicioDjb = (currentPageDjb - 1) * perPageDjb;
                this.currentBandDjb = currentPageDjb;
            }

            let params = {};

            if (this.inicioDjb == 0) {
                params["inicio"] = 0;
            } else {
                params["inicio"] = this.inicioDjb;
            }
            if (perPageDjb) {
                params["cantidad"] = perPageDjb;
            }

            params["orderBy"] = 1;
            params["orderDir"] = "desc";

            if (nombre || cedula) {
                params["filtros"] = {};
                if (nombre) {
                    params["filtros"]["nombres"] = nombre;
                }
                if (cedula) {
                    params["filtros"]["cedula"] = cedula;
                }
            }
            params["filtros"] = JSON.stringify(params["filtros"]);
            return params;
        },
        totalPaginasDjb(cant) {
            this.totalPaginaDjb = Math.ceil(cant / this.perPageDjb);
        },
        paginaPrimeraDjb() {
            this.currentPageDjb = 1;
            this.paginarDJB();
        },
        paginaAnteriorDjb() {
            if(this.currentPageDjb > 1) {
                this.currentPageDjb--;
            }
            this.paginarDJB();
        },
        paginaSiguienteDjb() {
            if(this.currentPageDjb < this.totalPaginaDjb) {
                this.currentPageDjb++;
            }
            this.paginarDJB();
        },
        paginaUltimaDjb() {
            this.currentPageDjb = this.totalPaginaDjb;
            this.paginarDJB();
        },
        handlePerPageDjb() {
            this.paginarDJB();
        },


        // Método para realizar la carga y el paginado de los datos de declaraciones juradas de conflictos de intereses
        paginarDJCI() {
            this.activePromisesDJCI++
            console.log('paginar DJCI');
            const params = this.getRequestParamsDJCI(
                this.inicioDjci,
                this.currentPageDjci,
                this.currentBandDjci,
                this.perPageDjci,
                this.nombre,
                this.cedula);

            datosService.getDatosAbiertosDjci(params)
                .then((response) => {
                    console.log('Esto trae: ', response.data);
                    let cantRegDjci = response.data.total;
                    if(cantRegDjci > 0) {
                        this.listadoDJCI = response.data.lista;
                        console.log('Listado DJCI: ', this.listadoDJCI);
                    } else {
                        this.msgDjci = 'No se encontraron registros';
                    }
                    this.totalPaginasDjci(response.data.total);
                    this.cantPaginasDjci = response.data.total;
                },
                (error) => {
                    this.content =
                    (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                }
            )
            .finally(() => {
                this.activePromisesDJCI--;
            })
        },
        getRequestParamsDJCI(inicioDjci, currentPageDjci, currentBandDjci, perPageDjci, nombre, cedula) {
            console.log("inicio: ", inicioDjci);
            console.log("currentPage: ", currentPageDjci);
            console.log("currentBand: ", currentBandDjci);
            console.log("perPage: ", perPageDjci);
            console.log("nombre: ", nombre);
            console.log("cedula: ", cedula);

            if (currentPageDjci >= currentBandDjci) {
                this.inicioDjci = (currentPageDjci - 1) * perPageDjci;
                this.currentBandDjci = currentPageDjci;
            } else {
                this.inicioDjci = (currentPageDjci - 1) * perPageDjci;
                this.currentBandDjci = currentPageDjci;
            }
            console.log("inicio: ", this.inicioDjci);

            let params = {};

            if (this.inicioDjci == 0) {
                params["inicio"] = 0;
            } else {
                params["inicio"] = this.inicioDjci;
            }
            if (perPageDjci) {
                params["cantidad"] = perPageDjci;
            }

            params["orderBy"] = 1;
            params["orderDir"] = "desc";

            if (nombre || cedula) {
                params["filtros"] = {};
                if (nombre) {
                    params["filtros"]["nombres"] = nombre;
                }
                if (cedula) {
                    params["filtros"]["cedula"] = cedula;
                }
                console.log("Filtro: ", params["filtros"]);
            }
            params["filtros"] = JSON.stringify(params["filtros"]);
            return params;
        },
        totalPaginasDjci(cant) {
            this.totalPaginaDjci = Math.ceil(cant / this.perPageDjci);
        },
        paginaPrimeraDjci() {
            this.currentPageDjci = 1;
            this.paginarDJCI();
        },
        paginaAnteriorDjci() {
            if(this.currentPageDjci > 1) {
                this.currentPageDjci--;
            }
            this.paginarDJCI();
        },
        paginaSiguienteDjci() {
            console.log('El current page anterior es: ', this.currentPageDjci);
            if(this.currentPageDjci < this.totalPaginaDjci) {
                this.currentPageDjci++;
            }
            console.log('El current page actual es: ', this.currentPageDjci);
            this.paginarDJCI();
        },
        paginaUltimaDjci() {
            this.currentPageDjci = this.totalPaginaDjci;
            this.paginarDJCI();
        },
        handlePerPageDjci() {
            this.paginarDJCI();
        },


        // Método para descargar pdf de declaraciones juradas de bienes y rentas
        descargarDjbPDF(id, idCabeceraDjb, nombres) {
            datosService.downloadDjbPDF(id)
                .then((response) => {
                    let fileURL = window.URL.createObjectURL(new Blob([response.data])); // URL del archivo PDF
                    const link = document.createElement('a'); // Crea un elemento <a> oculto
                    link.href = fileURL;
                    link.target = '_blank'; // Abrimos el enlace en una nueva pestaña
                    link.download = idCabeceraDjb + '_' + nombres + '.pdf'; // Nombre del archivo a descargar
                    document.body.appendChild(link); // Simulamos un clic en el enlace
                    link.click();
                    document.body.removeChild(link); // Eliminamos el elemento <a> del DOM
                },
                (error) => {
                    this.content =
                    (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                }
            )
        },

        // Método para descargar json de declaraciones juradas de bienes y rentas
        descargarDjbJSON(id, idCabeceraDjb, nombres) {
            datosService.downloadDjbJSON(id)
                .then((response) => {
                    const json = JSON.stringify(response.data);
                    const blob = new Blob([json], { type: 'application/json' }); // Crea un objeto Blob para el JSON
                    const url = window.URL.createObjectURL(blob); // Crea un enlace para descargar el Blob
                    const link = document.createElement('a'); // Crea un elemento <a> para simular un clic
                    link.href = url;
                    link.target = '_blank'; // Abre el enlace en una nueva pestaña si lo deseas
                    link.download = idCabeceraDjb + '_' + nombres + '.json'; // Nombre del archivo a descargar
                    document.body.appendChild(link); // Simula un clic en el enlace
                    link.click();
                    document.body.removeChild(link); // Elimina el elemento <a> y libera el objeto Blob
                    window.URL.revokeObjectURL(url);
                },
                (error) => {
                    this.content =
                    (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                }
            )
        },

        // Método para descargar pdf de declaraciones juradas de conflictos de intereses
        descargarDjciPDF(id, idCabeceraDjci, nombres) {
            datosService.downloadDjciPDF(id)
                .then((response) => {
                    let fileURL = window.URL.createObjectURL(new Blob([response.data])); // URL del archivo PDF
                    const link = document.createElement('a'); // Crea un elemento <a> oculto
                    link.href = fileURL;
                    link.target = '_blank'; // Abrimos el enlace en una nueva pestaña
                    link.download = idCabeceraDjci + '_' + nombres + '.pdf'; // Nombre del archivo a descargar
                    document.body.appendChild(link); // Simulamos un clic en el enlace
                    link.click();
                    document.body.removeChild(link); // Eliminamos el elemento <a> del DOM
                },
                (error) => {
                    this.content =
                    (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                }
            )
        },

        // Método para descargar json de declaraciones juradas de conflictos de intereses
        descargarDjciJSON(id, idCabeceraDjci, nombres) {
            datosService.downloadDjciJSON(id)
                .then((response) => {
                    const json = JSON.stringify(response.data);
                    const blob = new Blob([json], { type: 'application/json' }); // Crea un objeto Blob para el JSON
                    const url = window.URL.createObjectURL(blob); // Crea un enlace para descargar el Blob
                    const link = document.createElement('a'); // Crea un elemento <a> para simular un clic
                    link.href = url;
                    link.target = '_blank'; // Abre el enlace en una nueva pestaña si lo deseas
                    link.download = idCabeceraDjci + '_' + nombres + '.json'; // Nombre del archivo a descargar
                    document.body.appendChild(link); // Simula un clic en el enlace
                    link.click();
                    document.body.removeChild(link); // Elimina el elemento <a> y libera el objeto Blob
                    window.URL.revokeObjectURL(url);
                },
                (error) => {
                    this.content =
                    (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                }
            )
        }

    },

    beforeUnmount() {
        if (this.pdfBlobUrl) {
            URL.revokeObjectURL(this.pdfBlobUrl);
        }
    },

    mounted() { 
        console.log("mounted", this.activePromisesDJB, this.activePromisesDJCI);
    }
    // created() {
        
    // },


    // computed: {
        
    // }

}
</script>